import useFlag from 'lane-shared/hooks/useFlag';
import { FeatureFlag } from 'constants-flags';

export function useWorkOrdersCustomQuestionRequiredEnabled() {
  const isEnabled = useFlag<boolean>(
    FeatureFlag.WorkOrdersCustomQuestionRequired,
    false
  );

  return Boolean(isEnabled);
}
